import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function SubBanner({ title }) {
  return (
    <section className="sub_banner position-relative">
      <div className="container position-relative">
        <div className="row">
          <div className="col-12">
            <div className="sub_banner_content text-center">

              {/* HEADING ANIMATION */}
              <motion.h1
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.6 }}
              >
                {title}
              </motion.h1>

              {/* BREADCRUMB (slight delay for smooth feel) */}
              <motion.div
                className="box"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <Link to="/" className="text-decoration-none">
                  <span className="mb-0">Home</span>
                </Link>

                <span className="mb-0 slash"> / </span>

                <span className="mb-0 box_span">{title}</span>
              </motion.div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SubBanner;